import apiConfig from "../../utils/config.json";
import httpService from "../httpService";

const apiEndPoint = `${apiConfig.apiUrl}dpStaff/insert/center`;
const apiEndPointForCM = `${apiConfig.apiUrl}dpStaff/insert/centerInCharge`;
const apiEndPointForUserData = `${apiConfig.apiUrl}dpStaff/get/getAllCenterInCharge`;
const apiEndPointForLoginLogoutReport = `${apiConfig.apiUrl}dpStaff/get/getCenterDailyLoginLogoutReport`;
const apiEndPointForStudentLoginLogoutReport = `${apiConfig.apiUrl}dpStaff/get/getStudentDailyLoginLogoutReport`;

export function registerCenter(value) {
  const obj = {
    centerCode:value.centerCode,
    centerName:value.name,
    provinceID:value.province,
    districtID:value.district,
    address:value.address,
    pcCount:value.pcQty  
  };
  return httpService.post(apiEndPoint, obj);
}

export function registerCenterManager(value) {
  const obj = {
    centerCode:value.centerCode,
    name:value.name,
    email:value.email,
    phoneNumber:value.phone,
    address:value.address,
  };
    return httpService.post(apiEndPointForCM, obj);
  }

export function getUserData(value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {}
  };

  const keyword = value.search ? `?keyword=${value.search}` : '';
  return httpService.post(apiEndPointForUserData.concat(keyword), obj);
}

export function getCenterLoginLogoutReport(value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {
      centerCode: value?.centerCode || "",
      fromDate: value?.fromDate || "",
      toDate: value?.toDate || "",
    }
  };
  return httpService.post(apiEndPointForLoginLogoutReport, obj);
}

export function getStudentLoginLogoutReport(value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {
      centerCode: value?.centerCode || "",
      date: value?.date || "",
    }
  };
  return httpService.post(apiEndPointForStudentLoginLogoutReport, obj);
}

export default {
  registerCenter,
  registerCenterManager,
  getUserData,
  getCenterLoginLogoutReport,
  getStudentLoginLogoutReport
};
